import React, { useState, useEffect } from 'react';
import { getCurrentUserData } from '../utils/auth';
import { getUserInitials } from '../utils/userUtils';

/**
 * UserAvatar Component
 * Displays user profile picture or initials with gradient background
 * Automatically loads user data from localStorage
 */
const UserAvatar = ({ size = 'medium', className = '' }) => {
    const [currentUser, setCurrentUser] = useState(null);

    useEffect(() => {
        // Load current user information from localStorage first (for quick display)
        const userData = getCurrentUserData();
        if (userData) {
            setCurrentUser(userData);
        }
        
        // Then refresh from API to ensure we have the latest data (including picture)
        const refreshUserData = async () => {
            try {
                const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';
                const response = await fetch(`${apiUrl}/v1/auth/me`, {
                    credentials: 'include'
                });
                
                if (response.ok) {
                    const freshUserData = await response.json();
                    localStorage.setItem('currentUser', JSON.stringify(freshUserData));
                    setCurrentUser(freshUserData);
                }
            } catch (error) {
                console.error('Error refreshing user data:', error);
            }
        };
        
        refreshUserData();
    }, []);

    // Size variants
    const sizeClasses = {
        small: 'w-8 h-8 text-sm',
        medium: 'w-10 h-10 text-lg',
        large: 'w-12 h-12 text-xl'
    };

    const sizeClass = sizeClasses[size] || sizeClasses.medium;

    return (
        <>
            {currentUser?.picture ? (
                <img 
                    src={currentUser.picture} 
                    alt={currentUser.name || 'User'} 
                    className={`${sizeClass} rounded-full object-cover shadow-md hover:shadow-lg transition-shadow border-2 border-white ${className}`}
                />
            ) : (
                <div className={`${sizeClass} rounded-full bg-gradient-to-br from-blue-500 to-pink-500 flex items-center justify-center text-white font-bold shadow-md hover:shadow-lg transition-shadow border-2 border-white ${className}`}>
                    {getUserInitials(currentUser?.name)}
                </div>
            )}
        </>
    );
};

export default UserAvatar;

